export const TIMETRACKER = 'timetracker';